import React from 'react';
import { Link } from 'react-router-dom';
import { FiMessageCircle, FiMail } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const openCookieSettings = (event) => {
  event.preventDefault();
  window.dispatchEvent(new Event('dg:open-cookie-settings'));
};

const Footer = () => {
  return (
    <footer className="bg-slate-50 pt-24 pb-12 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-20">
          <div className="col-span-1">
            <div className="mb-6 h-16 md:h-20 mix-blend-multiply -ml-2">
              <img
                src="https://media-manager-c.questera.ai/greta-media/fafed1dc96bdeaff472e762fc9535f37237b73cd078ba929908d8fc9f91ee4faeb3717965c5074a04f18e80ee0d17e20/images/aW1hZ2UvcG5n/64321200e219a387529c007d184ece45.png"
                alt="DigitalGigs"
                className="h-full w-auto object-contain object-left scale-150 origin-left"
              />
            </div>
            <p className="text-slate-500 text-lg leading-relaxed font-medium mt-4">
              Boutique growth studio helping businesses scale through intelligent digital systems and premium development.
            </p>
          </div>
          <div>
            <h4 className="font-black text-slate-900 mb-8 text-sm uppercase tracking-widest">Navigation</h4>
            <ul className="space-y-4 text-slate-600 font-bold">
              <li><Link to="/services" className="hover:text-emerald-600 transition-all">Services</Link></li>
              <li><Link to="/projects" className="hover:text-emerald-600 transition-all">Recent Projects</Link></li>
              <li><Link to="/faq" className="hover:text-emerald-600 transition-all">FAQ</Link></li>
              <li><a href="/blog/" className="hover:text-emerald-600 transition-all">Blog</a></li>
              <li><Link to="/about" className="hover:text-emerald-600 transition-all">About</Link></li>
              <li><Link to="/opportunities" className="hover:text-emerald-600 transition-all">Join DigitalGigs</Link></li>
              <li><Link to="/affiliates" className="hover:text-emerald-600 transition-all">Affiliates</Link></li>
              <li><a href="/#contact" className="hover:text-emerald-600 transition-all">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-black text-slate-900 mb-8 text-sm uppercase tracking-widest">Connect</h4>
            <div className="space-y-4">
              <a href="mailto:digitalgig24@gmail.com" className="flex items-center text-slate-600 font-bold hover:text-emerald-600 transition-colors group">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3 shadow-sm border border-slate-100 group-hover:border-emerald-200 transition-all">
                  <SafeIcon icon={FiMail} className="text-lg" />
                </div>
                digitalgig24@gmail.com
              </a>
              <a href="https://go.digitalgigs.eu/chat" target="_blank" rel="noopener noreferrer" className="flex items-center text-slate-600 font-bold hover:text-emerald-600 transition-colors group">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3 shadow-sm border border-slate-100 group-hover:border-emerald-200 transition-all">
                  <SafeIcon icon={FiMessageCircle} className="text-lg" />
                </div>
                WhatsApp Support
              </a>
            </div>
          </div>
        </div>
        <div className="pt-12 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-sm font-bold text-slate-400 text-center md:text-left">
          <p>Copyright © 2026 DigitalGigs. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link to="/impressum" className="hover:text-emerald-600 transition-colors">Impressum</Link>
            <Link to="/privacy" className="hover:text-emerald-600 transition-colors">Privacy Policy</Link>
            <a href="#cookie-settings" onClick={openCookieSettings} className="hover:text-emerald-600 transition-colors">Cookie settings</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
